import { ERequestApiStatus } from '../../../types/appState';
import type { IChatProfile } from '../../../types/chatProfile';

export const mapResponse400 = (): IChatProfile => {
  return {
    clientInfo: null,
    status: ERequestApiStatus.Failed,
  };
};
